import { createClient } from '@supabase/supabase-js';
import { navigatorLock } from '@supabase/auth-js';
import { instrumentSupabaseClient } from '@sentry/browser';

const supabaseUrl = (import.meta.env.VITE_SUPABASE_URL || '').trim();
const supabaseKey = (import.meta.env.VITE_SUPABASE_ANON_KEY || '').trim();

if (!supabaseUrl || !supabaseKey) {
  console.warn('Supabase env vars not set. Check VITE_SUPABASE_URL and VITE_SUPABASE_ANON_KEY in .env.local');
}

// Safety net: o auth-js chama o Navigator Lock sem timeout (espera infinita),
// e o supabase-js não repassa a opção lockAcquireTimeout — o cap é aplicado
// aqui. Se um lock ficar órfão (aba congelada/descartada segurando o lock),
// as queries falham com erro visível em 15s em vez de congelar o app inteiro.
const lockWithTimeout: typeof navigatorLock = (name, acquireTimeout, fn) =>
  navigatorLock(name, acquireTimeout >= 0 ? acquireTimeout : 15_000, fn);

export const SUPABASE_URL = supabaseUrl || '';
export const SUPABASE_ANON_KEY = supabaseKey || '';
export const supabase = createClient(supabaseUrl || '', supabaseKey || '', {
  // Mesma detecção do default interno do auth-js: navigatorLock só quando
  // a Web Locks API existe (jsdom/testes não têm → fallback pro default).
  auth: typeof navigator !== 'undefined' && navigator.locks
    ? { lock: lockWithTimeout }
    : {},
});
instrumentSupabaseClient(supabase);

// Storage helpers
const BUCKET_NAME = 'avatars';
export const STORAGE_URL = `${SUPABASE_URL}/storage/v1/object/public/${BUCKET_NAME}`;

/**
 * Helper to construct the full image URL.
 * If the path is already a URL (starts with http), return it as is.
 * Otherwise, append it to the Supabase Storage bucket path.
 */
export const getStorageImageUrl = (path: string | null | undefined) => {
  if (!path) return '';
  if (path.startsWith('http')) return path;

  const cleanPath = path.split('/').map(part => encodeURIComponent(part)).join('/');
  return `${STORAGE_URL}/${cleanPath}`;
};

/**
 * Build a public URL for any Supabase Storage bucket.
 */
export const getPublicStorageUrl = (bucket: string, path: string) => {
  const cleanPath = path.split('/').map(part => encodeURIComponent(part)).join('/');
  return `${SUPABASE_URL}/storage/v1/object/public/${bucket}/${cleanPath}`;
};
